import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/chart/[symbol]/page.tsx");
